import { defineComponent, $prefix, setup as _setup } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/popup/vue";
import { iconClose } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

import "@opentiny/vue-theme-mobile/popup/index.css";
var $constants = {
  OVERFLOWHIDDEN: "tiny-overflow-hidde"
};
var __vue2_script = defineComponent({
  name: $prefix + "Popup",
  emits: ["open", "close", "update:modelValue", "click-overlay", "closed", "opened", "click"],
  components: {
    IconClose: iconClose()
  },
  props: {
    _constants: {
      type: Object,
      default: function _default() {
        return $constants;
      }
    },
    closeIcon: {
      type: String,
      default: "cross"
    },
    closeIconPosition: {
      type: String,
      default: "top-right"
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    closeable: {
      type: Boolean,
      default: true
    },
    duration: [Number, String],
    lazyRender: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    modelValue: Boolean,
    overlay: {
      type: Boolean,
      default: true
    },
    overlayClass: String,
    overlayStyle: Object,
    popupClass: String,
    popupStyle: Object,
    position: {
      type: String,
      default: "center"
    },
    round: Boolean,
    safeAreaInsetBottom: Boolean,
    transition: String,
    zIndex: [Number, String]
  },
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api,
      mono: true
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("transition", {
    attrs: {
      "name": _vm.state.transitionName
    },
    on: {
      "after-enter": _vm.opened,
      "after-leave": _vm.closed
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.modelValue,
      expression: "modelValue"
    }],
    ref: "popup",
    staticClass: "tiny-popup",
    class: [_vm.round ? "tiny-popup--round" : "", _vm.position ? "tiny-popup--" + _vm.position : "", _vm.popupClass],
    style: _vm.state.style,
    on: {
      "click": function click($event) {
        return _vm.$emit("click");
      }
    }
  }, [_vm._t("default"), _vm.closeable ? _c("icon-close", {
    staticClass: "tiny-popup__close-icon tiny-popup__close-icon--top-right",
    attrs: {
      "fill": "#c8c9cc",
      "tabindex": "0"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e()], 2)]), _c("transition", {
    attrs: {
      "name": "tiny-fade"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.opened && _vm.overlay,
      expression: "state.opened && overlay"
    }],
    staticClass: "tiny-overlay",
    class: _vm.overlayClass,
    style: _vm.state.overlayStyle,
    on: {
      "click": _vm.clickOverlay
    }
  }, [_vm._t("overlay")], 2)])], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var Popup = /* @__PURE__ */ function() {
  return __component__.exports;
}();
var version = "2.10.0";
Popup.model = {
  prop: "modelValue",
  event: "update:modelValue"
};
Popup.install = function(Vue) {
  Vue.component(Popup.name, Popup);
};
Popup.version = version;
export {
  Popup as default
};
